import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateMeterModuleArg, UpdateMeterModuleResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdateMeterModule = (): UseMutationResult<UpdateMeterModuleResult, unknown, UpdateMeterModuleArg> => {
  const queryClient = useQueryClient();
  const { meterModulesApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModules.updateOne(),
    mutationFn: async (arg: UpdateMeterModuleArg) => await meterModulesApiClient.update(arg),
    onError: error => {
      notify.error({
        message: 'There was an error while updating module',
        description: getErrorMessage(error),
      });
    },
    onSuccess: module => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModules.one(module.id));
      notify.success({
        message: 'Module updated',
      });
    },
  });
};
